// extracted by mini-css-extract-plugin
export var backdropBlur = "_mg-0";
export var contentCard = "_mg-5";
export var frame = "_mg-2";
export var image = "_mg-4";
export var imagePane = "_mg-3";
export var modal = "_mg-1";